import type { BrandedFare } from '@/app/api/hotel-detail/branded-fares/route.ts';
import type { InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';

export const BRANDED_FARES_CLICKED = 'BRANDED_FARES_CLICKED';
export const BRANDED_FARES_CLICKED_VERSION = '1.0';

export type BrandedFaresClickedPayload = {
  searchId: string;
  productDetailKey: string;
  flightClickId: string;
  brandedFareName: string;
  brandedFarePriceAmount: number;
  brandedFareCurrency: string;
};

export type BrandedFaresClickedParams = {
  initialParams: Pick<InitialParams, 'hdpSearchId' | 'productDetailKey' | 'flightClickId'>;
  brandedFare: BrandedFare;
  selectedMealPlan: MealPlanType | undefined;
  currency: string;
};

export const createBrandedFaresClickedPayload = ({
  initialParams,
  brandedFare,
  selectedMealPlan,
  currency,
}: BrandedFaresClickedParams): BrandedFaresClickedPayload => ({
  searchId: initialParams.hdpSearchId,
  productDetailKey: initialParams.productDetailKey,
  flightClickId: initialParams.flightClickId || '',
  brandedFareName: brandedFare.fareId,
  brandedFarePriceAmount: Number(((selectedMealPlan?.finalTotalPrice ?? 0) + brandedFare.priceDifference).toFixed(2)),
  brandedFareCurrency: currency,
});
